import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { Property } from './types';
import { Loader } from 'semantic-ui-react';

const Input = styled.input`
  background: #f7f7f9;
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  height: 48px;
  :focus {
    outline: none;
  }
`;

interface Props {
  changePropertyInfo?: (label: keyof Partial<Property>, value: any, index: number) => void;
  index?: number;
  property?: Property;
  findMatches?: (e: any) => void;
  error?: any;
  isLoading?: boolean;
}

const PropertySection = (props: Props) => {
    useEffect(() => {}, [props.property]);
    return (
      <div>
        <div style={{ display: 'flex', marginTop: 24 }}>
          <div style={{ flexDirection: 'column', display: 'flex', position: 'relative' }}>
            <label>Address</label>
            <Input
              style={{ width: 630, marginRight: 8, marginTop: 8 }}
              onChange={e => {
                props.changePropertyInfo('address', e.target.value, props.index);
                props.findMatches(e);
              }}
              value={props.property.address || ''}
            />
            {/* <span style={{ position: 'absolute', top: 52, right: 32 }}>
              <Loader active={props.isLoading} size="tiny" />
            </span> */}
            {props.error}
          </div>
          <div style={{ flexDirection: 'column', display: 'flex' }}>
            <label>Unit #</label>
            <Input
              style={{ width: 60, marginTop: 8 }}
              onChange={e => props.changePropertyInfo('addressLine2', e.target.value, props.index)}
              value={props.property.addressLine2 || ''}
            />
          </div>
        </div>
  
        <div style={{ display: 'flex', marginTop: 24 }}>
          {props.property?.selectedCity?.stateCode !== 'NJ' && (
            <div style={{ flexDirection: 'column', display: 'flex' }}>
              <label>
                {props.property?.selectedCity?.municipalityType === 'Borough' ? 'Borough' : 'Section'}
              </label>
              <Input
                style={{ width: 228, marginRight: 8, marginTop: 8 }}
                onChange={e => props.changePropertyInfo('section', e.target.value, props.index)}
                value={props.property.section || ''}
              />
            </div>
          )}
          <div style={{ flexDirection: 'column', display: 'flex' }}>
            <label>Block</label>
            <Input
              style={{ width: 228, marginTop: 8, marginRight: 10 }}
              onChange={e => props.changePropertyInfo('block', e.target.value, props.index)}
              value={props.property.block || ''}
            />
          </div>
          <div style={{ flexDirection: 'column', display: 'flex' }}>
            <label>Lot</label>
            <Input
              style={{ width: 228, marginTop: 8 }}
              onChange={e => props.changePropertyInfo('lot', e.target.value, props.index)}
              value={props.property.lot || ''}
            />
          </div>
          {props.property?.selectedCity?.stateCode === 'NJ' && (
            <div style={{ flexDirection: 'column', display: 'flex', marginLeft: 10 }}>
              <label>Qualifier</label>
              <Input
                style={{ width: 228, marginTop: 8 }}
                onChange={e => props.changePropertyInfo('qualifier', e.target.value, props.index)}
                value={props.property.qualifier || ''}
              />
            </div>
          )}
        </div>
      </div>
    );
  };

export default PropertySection;
